export default __webpack_public_path__ + "static/media/feature-info.bb0f4e99.png";